<template>
    <el-container>
        <el-main>
            <el-row>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/modules/prepare/prepare' }">分货管理</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">发货</a></el-breadcrumb-item>
                </el-breadcrumb>
            </el-row>

            <order-info :order-info="orderInfo" style="margin-top: 10px; margin-bottom: 10px"></order-info>
            <goods-list ref="goodsList" type="query" :data="orderInfo" :typeWaybillMode="typeWaybillMode" style="margin-bottom: 10px"></goods-list>

            <detail-list ref="detailList" type="add" :orderInfo="orderInfo"></detail-list>

            <el-row style="text-align: center">
                <el-button @click="back">返回</el-button>
                <el-button type="primary" @click="getOut">发货</el-button>
            </el-row>
        </el-main>
    </el-container>
</template>
<script>
import {getPrepareList} from "@/modules/server-api/prepare/prepare";
import {orderPdApi} from '@/modules/server-api/orderPd/order';
import {$busErrorCode} from '@/modules/commodity-sys/common.js';
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import SearchInput from '@/modules/wms-manage/components/searchInput.vue';
import {getApprovalDetail} from "@/modules/server-api/prepare/approvalDetail";

import orderInfo from "../orderInfo";
import goodsList from "../goodsList";
import detailList from "../detailList";
export default {
    components: {
        orderInfo,
        goodsList,
        detailList,
        GcCmpVsTable,
        GcCmpVsInput,
        SearchInput
    },
    data() {
        return {
            orderInfo:{},
            tabIndex: 0,
            filterText: "",
            options: [],
            priceExtraTh: [], //动态表头
            tableData: [],
            detail: [],
            isEditReceiveUser: false,
            storeOptions: [],//门店选项
            storeInfo: [],//门店信息
            isGetStore: false,//是否获取到门店
            selectedListGoods: [],//列表选择的商品
            searchGoodsList: [],//筛选的商品
            goodsList: [],//商品list
            goodsLists: [],
            goodsName: "",
            goodsNames: "",
            orderGoodsList: [],
            snData: [],
            currSnCode: "",//添加SN码
            showSnPop: false,
            deletePopFlag: false,
            sendPopFlag: false,
            typeWaybillMode:""
        }
    },
    mounted() {
        this.orderInfo = this.$route.query;
        // this.editReceiveUsers();
        // this.ApprovalDetailed();
        this.getPriceDetailList();
        this.getApprovalDetailedList();
    },
    methods: {
        //获取订单信息
        async getPriceDetailList() {
            //根据入库单获取商品
            let rep = await getPrepareList.getPriceDetailList({
                orderNo: this.orderInfo.orderNo
            });
            if (rep.succ === 1) {
                let resList = rep.result.goodsList;
                this.orderInfo = rep.result.order;
                // 根据状态不同，显示不同
                let string = this.orderInfo.waybillMode
                    console.log('this.orderInfo.waybillMode',this.orderInfo)
                    this.typeWaybillMode = string == '主动配货' ? '主动配货量' : '门店要货量'

                this.tableData = resList.map(item => {
                    console.log('item', item)
                    return item;
                });
                this.$refs.goodsList.addGoods( this.tableData );
            }
        },
        getApprovalDetailedList(){
            getApprovalDetail.getApprovalDetailedList({orderNo:this.orderInfo.orderNo}).then( resp => {
                if ( resp ){
                    console.log( 'getApprovalDetailedList', resp )
                    this.$refs.detailList.addDetails( resp.result.list )
                }
            })
        },
        //获取详情信息
        async editReceiveUsers() {
            let res = await getPrepareList.getPriceList({
                orderNo: this.detail.orderNo,
                waybillStatus: this.detail.waybillStatus,
                waybillUser: this.detail.waybillUser,
                waybillMode: this.detail.waybillMode
            });
            console.log(res, "====")
            if (res.succ == 1) {
                this.$notifySuccess('收货人信息保存成功');
                this.isEditReceiveUser = false;
                // this.$refs["skuItem"].getOrderGoodsList();
            } else {
                return this.$notifyError(res.error);
            }
        },
        //配货明细列表
        async ApprovalDetailed() {
            let rep = await getPrepareList.ApprovalDetailed({
                orderNo: this.orderNo,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            });
            console.log(rep);
            if (rep.succ == 1) {
                let resList = rep.result.list;
                this.goodsLists = resList;
                this.searchGoodsList = this.goodsLists;
            }
        },
        //查询商品
        searchGoods() {
            let self = this;
            if (this.goodsNames != "") {
                this.goodsLists = this.searchGoodsList.filter((item, index) => {

                    if (
                        (item.goodsName && (item.goodsName.indexOf(self.goodsNames) > -1))
                        || (item.skuCode && (item.skuCode.indexOf(self.goodsNames) > -1))
                        || (item.barCode && (item.barCode.indexOf(self.goodsNames) > -1))
                    ) {
                        return item;
                    }
                })
            } else {
                this.goodsLists = this.searchGoodsList;
            }
        },
        async deleteSnCode() {
            let res = await orderPdApi.deleteTempSn({
                "orderNo": this.orderNo,
                skuCode: this.currSkuCode,
                snCode: this.currDelSn
            });
            if (res.succ == 1 && res.code != $busErrorCode) {
                this.goodsLists[this.currIndex].snList = this.goodsLists[this.currIndex].snList.filter(item => item != this.currDelSn);
                this.goodsLists[this.currIndex].sendNum = this.goodsLists[this.currIndex].snList.length;
                this.snData = this.snData.filter(item => item != this.currDelSn);
                this.deletePopFlag = false;
                //更新父级
                this.$emit("uptSkuItems", this.goodsLists);
            } else {
                this.$notifyError(res.error);
            }
        },

        async saveOneSn(skuCode, snCodes) {
            let res = await orderPdApi.saveSN({
                "orderNo": this.orderNo,
                detail: [{
                    skuCode: skuCode,
                    snCodes: snCodes
                }]
            });
            if (res.succ == 1 && res.code != $busErrorCode) {
                this.$emit("uptSkuItems", this.orderGoodsList);
                this.$notifySuccess('添加成功');
            } else {
                this.$notifyError(res.error);
            }
        },
        showSnDetail(item, cIndex) {
            this.showSnPop = true;
            this.currIndex = cIndex;
            this.currSkuCode = item.skuCode;
            this.currSkuName = item.skuName;
            this.snData = item.snList;
        },
        handleCancel() {
            this.snData = [];
            this.showSnPop = false;
        },
        //删除sn码
        confirmDeletSn(snCode) {
            this.currDelSn = snCode;
            this.deletePopFlag = true;
        },
        beforeSend() {
            let lessNum = 0;
            this.detail.skuItems.map((item) => {
                if (item.sendNum < item.num) {
                    lessNum++;
                }
            });
            if (lessNum > 0) {
                // this.$notifyError('还差' + lessNum + '种商品未录入',);
                this.$vs.dialog({
                    type: "confirm",
                    title: `操作提示`,
                    text: `发货数量与订单数量不一致，是否确认发货`,
                    acceptText: "发货",
                    cancelText: "取消",
                    accept: () => {
                        this.doSendOrder();
                    },
                });
            } else {
                this.sendPopFlag = true
            }
        },
        //发货
        // getOut() {
        //     //校验发货录入数量是否等于订单数
        //     let lessNum = 0;
        //     // this.detail.skuItems.map((item) => {
        //     //     if (item.sendNum != item.num) {
        //     //         lessNum++;
        //     //     }
        //     // });
        //     if (lessNum > 0) {
        //         this.$vs.dialog({
        //             type: "confirm",
        //             title: `操作提示`,
        //             text: `发货数量与订单数量不一致，是否确认发货`,
        //             acceptText: "发货",
        //             cancelText: "取消",
        //             accept: () => {
        //                 this.doSendOrder();
        //             },
        //         });
        //     } else {
        //         this.doSendOrder();
        //     }
        // },
         // 发货方法--接口
       async getOut(){
            let arr = {orderNo:this.orderInfo.orderNo}
                     console.log('arr',arr)
                    let res = await getPrepareList.putData(arr)
                    console.log('res',res)
                    if(res.code != 200){
                        this.$notifyError(res.data);
                    }
                    else{
                        sessionStorage.removeItem("res");
                        this.$notifySuccess('发货成功');
                        this.$router.push({ path: '/modules/prepare/prepare'}).catch(() => {});
                    }
                    // this.sendPopFlag = false
                    

                    
        },
        // 返回
        back(){
            this.$router.push({path: '/modules/prepare/prepare'}).catch(() => {
                });
        }
    }
}
</script>
<style scoped>

.bottom .add {
    border: 1px solid #4090FF;
    background-color: white !important;
    color: #4090FF;
}

.back .fh {
    background-color: white !important;
    border: 1px solid black;
    color: black;
}

.quNo .qx {
    background-color: white !important;
    border: 1px solid black;
    color: black;
}

.bottom .add {
    border: 1px solid #4090FF;
    background-color: white !important;
    color: #4090FF;
}

.quNo .qx {
    background-color: white !important;
    border: 1px solid black;
    color: black;
}

</style>